import { isVnextModel, vnextOpContracts } from "@cadenza/rad-domain";
import { normalizeActivityKind } from "../activityKind.js";

const isEmpty = (value) => {
  if (value === undefined || value === null) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  return false;
};

export const enforceVnextRequiredArgs = (rad, op, values) => {
  if (!isVnextModel(rad)) return;
  const contract = vnextOpContracts[op];
  if (!contract) return;
  const missing = contract.requiredArgs.filter((arg) => isEmpty(values?.[arg]));
  if (missing.length === 0) return;
  throw new Error(`${op} missing required args: ${missing.join(", ")}`);
};

export const inferActivityContract = ({ activity, target }) => {
  const className = target?.class || target?.className || target?.type;
  const activityKind = normalizeActivityKind(activity?.kind ?? activity?.type);
  if (className === "role") {
    return {
      op: "addActivityToRole",
      args: {
        roleId: target?.id,
        activityKind,
      },
    };
  }
  return {
    op: "addActivityToThread",
    args: {
      threadId: target?.id,
      activityKind,
    },
  };
};
